import types from 'store/notifications/types';

const fetchNotifications = () => ({
  type: types.FETCH_NOTIFICATIONS,
});

const fetchNotificationsStart = () => ({
  type: types.FETCH_NOTIFICATIONS_START,
});

const fetchNotificationsSuccess = (data, isNotReadList, newsModal = {}) => ({
  type: types.FETCH_NOTIFICATIONS_SUCCESS,
  payload: { data, isNotReadList, newsModal },
});

const updateNotificationReadSuccess = (id, isNotReadList) => ({
  type: types.UPDATE_NOTIFICATION_READ_SUCCESS,
  payload: { id, isNotReadList },
});

const updateNotificationNotRead = (isNotReadList) => ({
  type: types.UPDATE_NOTIFICATION_NOT_READ,
  payload: isNotReadList,
});

const addNotificationModal = (id) => ({
  type: types.ADD_NOTIFICATION_MODAL,
  payload: { id },
});

const fetchNotificationsError = ({ error, scope }) => ({
  type: types.FETCH_NOTIFICATIONS_ERROR,
  payload: error,
  scope,
});

const updateNotificationRead = (id, isUpdateRead) => ({
  type: types.UPDATE_NOTIFICATION_READ,
  payload: { id, isUpdateRead },
});

const toggleNewsModal = () => ({
  type: types.TOGGLE_NEWS_MODAL,
});

const toggleTooltip = (data) => ({
  type: types.TOGGLE_TOOLTIP,
  payload: data,
});

const changeNewsModalStatus = (isShow) => ({
  type: types.CHANGE_NEWS_MODAL_STATUS,
  payload: isShow,
});

export default {
  fetchNotifications,
  fetchNotificationsStart,
  fetchNotificationsSuccess,
  updateNotificationReadSuccess,
  fetchNotificationsError,
  updateNotificationRead,
  toggleNewsModal,
  toggleTooltip,
  addNotificationModal,
  changeNewsModalStatus,
  updateNotificationNotRead,
};
